import { ScrutinyTab } from '../ScrutinyTab';
import { Button } from 'primereact/button';
import React, { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { getAllDetails, postAllData } from '../../../service/ProductService';
import { SAVEDEGREEADDITIONSCRUTINY, SCRUTINYAPPTRANSFER, SCRUTINYBYRNO, SEARCHAPPLICATIONSDEGREEADD } from '../../../config/ApiConstant';
import { DEGREENAME } from '../../../appconfig/Settings';
import { convertDateTime, formatDate, formatMonth } from '../../../appconfig/AppHelper';
import { useNavigate, useParams } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { combinedFullNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';
import Loader from '../../../components/Loadeer/Loader';
import FormWizard from 'react-form-wizard-component';
import 'react-form-wizard-component/dist/style.css';
import { Checkbox } from 'primereact/checkbox';
import ScrutinySuccessModal from '../../../components/Modal/ScrutinySuccessModal';
import { InputTextarea } from 'primereact/inputtextarea';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
export const DegreeAdditionScrutinySteps = () => {
    document.title = 'Degree Addition Scrutiny | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const navigate = useNavigate();

    //scrutinyRemainingList

    const [applicationDetails, setApplicationDetails] = useState<any>({});
    const [scrutinyDetails, setScrutinyDetails] = useState<any>({});

    //tabIndex
    const [activeIndex, setActiveIndex] = useState<any>();

    //role
    const [roleName, setRoleName] = useState<any>(null);

    //name
    const [userName, setUserName] = useState<string>('');

    //loaders
    const [pageLoad, setPageLoad] = useState<boolean>(true);

    //scrutiny check dialog
    const [scrutinyCheckDialog, setScrutinyCheckDialog] = useState<boolean>(false);
    const [saveButtonLoader, setSaveButtonLoader] = useState<boolean>(false);
    const [successDialog, setSuccessDialog] = useState<boolean>(false);
    const [successDetails, setSuccessDetails] = useState<any>({});

    //scrutinyCheckBtnTitle
    const [scrutinyCheckBtnTitle, setScrutinyCheckBtnTitle] = useState<any>(null);
    const [scrutinyCheckBtnSpinner, setScrutinyCheckBtnSpinner] = useState<boolean>(false);

    const { rNo, fileNo, status }: any = useParams();

    useEffect(() => {
        // Get Token from LocalStorage
        let token: any = localStorage.getItem('token');
        let role: any = localStorage.getItem('role');
        let name: any = localStorage.getItem('name');

        //Token Decode
        if (!window.cn(token)) {
            if (!window.cn(role)) {
                let roleNm = role;
                let selectedTab = atob(status);
                setActiveIndex(Number(selectedTab));
                setRoleName(roleNm);
                setUserName(name);

                if (!window.cn(fileNo) && !window.cn(rNo)) {
                    let fileNumber: any = atob(fileNo);
                    let rNumber: any = atob(rNo);

                    searchScrutiny(fileNumber, rNumber);
                }
            }
        }
    }, [status]);

    //seasr serutiny api
    const searchScrutiny = async (fileNo: any, rNo: any) => {
        try {
            setPageLoad(true);

            const response = await getAllDetails(SEARCHAPPLICATIONSDEGREEADD + '?SrNo=' + fileNo + '&RNo=' + rNo);
            if (response) {
                setApplicationDetails(response);

                try {
                    const innerResponse = await getAllDetails(SCRUTINYBYRNO + '?RNo=' + rNo + '&applicationTypeName=' + DEGREENAME);
                    if (innerResponse) {
                        setScrutinyDetails(innerResponse);
                    }
                } catch (error: any) {
                    if (error.response) {
                        //Spinner False and Set Toast
                        toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                    }
                }

                setPageLoad(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //handle change
    const handleChange = (e: any, name: string) => {
        let checked;
        if (e.checked === true) {
            checked = 1;
        } else {
            checked = 0;
        }
        let val = checked;
        setScrutinyDetails({ ...scrutinyDetails, [name]: val });
    };

    //handleNoteChnage
    const handleNoteChange = (e: any, name: string) => {
        let val = (e.target && e.target.value) || e.value || '';
        setScrutinyDetails({ ...scrutinyDetails, [name]: val });
    };

    //open scrutiny Check dialof
    const scrutinyCheckOpen = (btnName: string) => {
        setScrutinyCheckDialog(true);
        setScrutinyCheckBtnTitle(btnName);
    };

    //const hidescrutinyCheckDialog
    const closeScrutinyCheckDialog = () => {
        setScrutinyCheckDialog(false);
    };

    //saveScrutiny
    const saveScrutiny = async () => {
        try {
            setSaveButtonLoader(true);

            // Degree Object Remove If Exist
            if (scrutinyDetails?.degree !== undefined) {
                delete scrutinyDetails.degree;
            }

            let allData = { ...scrutinyDetails };

            //Request Data
            let requestData = allData;
            requestData['RNo'] = atob(rNo);

            if (roleName == 'Scrutiny Manager') {
                requestData['prepared_by'] = userName;
            }

            if (roleName == 'Sub Registar') {
                requestData['checked_by'] = userName;
            }

            if (roleName == 'Registar') {
                requestData['approved_by'] = userName;
            }

            const response = await postAllData(SAVEDEGREEADDITIONSCRUTINY, requestData);
            if (response) {
                setSuccessDetails(response);
                setSaveButtonLoader(false);
                setScrutinyDetails({});
                successDetailfn();
            }
        } catch (error: any) {
            if (error.response) {
                setSaveButtonLoader(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    const successDetailfn = () => {
        if (successDetails && !window.cn(successDetails)) {
            setTimeout(() => {
                setSuccessDialog(true);
            }, 1000);
        }
    };

    // Modal Goto App Call
    const goToApp = () => {
        setSuccessDialog(false);
        navigate(`/app/scrutiny/degree-addition-scrutiny/${btoa(activeIndex)}`);
    };

    // Get Name
    let name = `${!window.cn(applicationDetails?.StudL) ? applicationDetails?.StudL : ''} ${!window.cn(applicationDetails?.StudF) ? applicationDetails?.StudF : ''} ${!window.cn(applicationDetails?.StudM) ? applicationDetails?.StudM : ''}`;

    //view documensts
    const viewDocuments = () => {
        const docUrl = `/app/scrutiny/viewOtherDocument/${fileNo}/${window.btoa(DEGREENAME)}/${rNo}`;
        window.open(docUrl, '_blank');
    };

    //check Scrutiny back to verification or pending
    const checkScrutiny = async (status: any) => {
        try {
            setScrutinyCheckBtnSpinner(true);

            //Request Data
            let requestData = {
                RNo: atob(rNo),
                reentryAppScrutinyStatus: status
            };
            //Api Call
            const response = await postAllData(SCRUTINYAPPTRANSFER, requestData);
            if (response) {
                setScrutinyCheckBtnSpinner(false);
                setScrutinyCheckDialog(false);
                setScrutinyDetails({});
                toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                setTimeout(() => {
                    navigate(`/app/scrutiny/degree-addition-scrutiny/${btoa(activeIndex)}`);
                }, 1500);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setScrutinyCheckBtnSpinner(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    return (
        <>
            <ScrutinyTab mainTabLabel="Scrutiny (Degree Additional)" />

            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Scrutiny'} pageName={'Degree Addition Scrutiny'} pageTitle={'Degree Addition Scrutiny'} goToPage={true} />

            <div className="grid crud-demo mt-4">
                <div className="col-12">
                    <div className="card">
                        <div className="grid ">
                            <div className="field col-12 md:col-5">
                                <div className="flex mb-3">
                                    <b className="detail_title" style={{ minWidth: '100px' }}>
                                        Full Name :{' '}
                                    </b>
                                    <p className="detail_name">{name}</p>
                                </div>

                                <div className="flex">
                                    <b className="detail_title" style={{ minWidth: '100px' }}>
                                        Date :
                                    </b>
                                    <p className="detail_name">{!window.cn(applicationDetails?.EntDt) ? formatDate(applicationDetails?.EntDt) : ''}</p>
                                </div>
                            </div>
                            <div className="field  col-12 md:col-3">
                                <div className="flex mb-3">
                                    <b className="detail_title" style={{ minWidth: '100px' }}>
                                        Reg No :
                                    </b>
                                    <p className="detail_name">{applicationDetails?.RegNo}</p>
                                </div>
                                <div className="flex">
                                    <b className="detail_title" style={{ minWidth: '100px' }}>
                                        Verified By :
                                    </b>
                                    <p className="detail_name">{!window.cn(applicationDetails?.verified_by) ? applicationDetails?.verified_by : ''}</p>
                                </div>
                            </div>
                            <div className="field flex flex-column col-12 md:col-4 align-items-end">
                                <img
                                    src={applicationDetails?.Image}
                                    style={{
                                        border: '1px solid black'
                                    }}
                                    alt="User"
                                    width={'120px'}
                                />
                                <div className="flex mt-3">
                                    <Button label="View Document" onClick={() => viewDocuments()}></Button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <FormWizard
                            stepSize="sm"
                            nextButtonTemplate={(handleNext) => (
                                <>
                                    <Button label="Next" onClick={handleNext} className="ml-2"></Button>
                                </>
                            )}
                            backButtonTemplate={(handlePrevious) => (
                                <>
                                    <Button label="Back" onClick={handlePrevious}></Button>
                                </>
                            )}
                            finishButtonTemplate={(handleComplete) => <></>}
                        >
                            <FormWizard.TabContent title="">
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">1. Whether requisite fees and paid ? Mention receipt no. and date.</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.FeePaid === 1 ? true : false} onChange={(e: any) => handleChange(e, 'FeePaid')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <div className="flex">
                                            <p className="scrutiny_data"> {!window.cn(applicationDetails?.bill) ? applicationDetails?.bill?.BillNo : ''}</p>
                                            <p className="scrutiny_data ml-2"> {!window.cn(applicationDetails?.bill) ? formatDate(applicationDetails?.bill?.billDt) : ''}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">2. Whether attested copies of pasport size photographs attached ?</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.Photoattst === 1 ? true : false} onChange={(e: any) => handleChange(e, 'Photoattst')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">3. Whether candidate is adove 18 years ? Mention birth date and place.</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.BrthVld === 1 ? true : false} onChange={(e: any) => handleChange(e, 'BrthVld')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <div className="flex">
                                            <p className="scrutiny_data"> {!window.cn(applicationDetails?.BOD) ? formatDate(applicationDetails?.BOD) : ''}</p>
                                            <p className="scrutiny_data ml-2"> {!window.cn(applicationDetails?.PofBOD) ? applicationDetails?.PofBOD : ''}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">4. Whether the place of work / Residence is located in Gujarat : mention the Name of Place :</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.ResLoc === 1 ? true : false} onChange={(e: any) => handleChange(e, 'ResLoc')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <div className="flex">
                                            <p className="scrutiny_data"> {!window.cn(applicationDetails?.PAddress) ? applicationDetails?.PAddress : ''}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">5. Whether the proof of residence is attacthed ? Ration card / Telephone Bill / Light Bill / Passport / other..</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.ResProf === 1 ? true : false} onChange={(e: any) => handleChange(e, 'ResProf')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data"> 6. Whether necessary true copies are submittted with the application :</p>
                                    </div>
                                    <div className="field col-12 md:col-1"></div>
                                    <div className="field col-12 md:col-3"></div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(A) School Leaving / Birth Certificate :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.SLertf === 1 ? true : false} onChange={(e: any) => handleChange(e, 'SLertf')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data">{applicationDetails?.HSCSNm}</p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4"> (B) New S.S.C / H.S.C Cretificate Marksheet :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.HScCertf === 1 ? true : false} onChange={(e: any) => handleChange(e, 'HScCertf')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data">{applicationDetails?.HSCBrd}</p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4"> (C) Degree / Diploma Marksheet</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.DegMrksht === 1 ? true : false} onChange={(e: any) => handleChange(e, 'DegMrksht')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data">{applicationDetails?.HSCYr}</p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(D) Practical Training Certificate :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.TrainCertf === 1 ? true : false} onChange={(e: any) => handleChange(e, 'TrainCertf')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(E) College Passing Cert. / Original Reg. Certificate of other state :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.PorRCertf === 1 ? true : false} onChange={(e: any) => handleChange(e, 'PorRCertf')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(F) Degree / Diploma Certificate in Pharmacy :</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.DDInPhmcy === 1 ? true : false} onChange={(e: any) => handleChange(e, 'DDInPhmcy')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">7. Details of college / Institute Qualification :</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.Qualification === 1 || scrutinyDetails?.Qualification === '1' ? true : false} onChange={(e: any) => handleChange(e, 'Qualification')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <p className="scrutiny_data">{scrutinyDetails?.degree?.DegNm}</p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(A) State ( Mention Name ) :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.State === 1 || scrutinyDetails?.State === '1' ? true : false} onChange={(e: any) => handleChange(e, 'State')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data">{!window.cn(scrutinyDetails?.degree?.get_university_to_college) ? scrutinyDetails?.degree?.get_university_to_college?.StateNm : ''}</p>
                                    </div>
                                </div>
                                <div className="grid">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(B) Name and Address of college / Institute :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.ColNm === 1 || scrutinyDetails?.ColNm === '1' ? true : false} onChange={(e: any) => handleChange(e, 'ColNm')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data">
                                            {!window.cn(scrutinyDetails?.degree) || !window.cn(scrutinyDetails?.degree?.get_university_to_college) ? (
                                                <div>
                                                    {scrutinyDetails?.degree?.ColNm}
                                                    <br />
                                                    {scrutinyDetails?.degree?.get_university_to_college?.Address}
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4"> (C) University Name and Place :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.UniNm === 1 || scrutinyDetails?.UniNm === '1' ? true : false} onChange={(e: any) => handleChange(e, 'UniNm')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data">{!window.cn(scrutinyDetails?.degree?.get_university_to_college) ? scrutinyDetails?.degree?.get_university_to_college?.university : ''}</p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(D) Month and Year of admission in the college :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.AdminYr === 1 ? true : false} onChange={(e: any) => handleChange(e, 'AdminYr')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data"> {!window.cn(scrutinyDetails?.degree) ? formatMonth(scrutinyDetails?.degree?.JoinDt) : ''}</p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(E) Month and Year of Completion Of Study :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.PassYr === 1 ? true : false} onChange={(e: any) => handleChange(e, 'PassYr')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data"> {!window.cn(scrutinyDetails?.degree) ? formatMonth(scrutinyDetails?.degree?.PassDt) : ''}</p>
                                    </div>
                                </div>
                            </FormWizard.TabContent>
                            <FormWizard.TabContent title="">
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data">8. Whether Cretificate of College leaving / College Bonafied is attached. :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={false}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data">9. No of Trials </p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.Trials === 1 ? true : false} onChange={(e: any) => handleChange(e, 'Trials')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data">10. Whether copies of all marksheets attached ? if Not mention Details : </p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.AllMrksht === 1 ? true : false} onChange={(e: any) => handleChange(e, 'AllMrksht')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data"> 11. Whether Provisional/ Original Certificate issued by the examining authority is attached :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.POrOExaAtt === 1 ? true : false} onChange={(e: any) => handleChange(e, 'POrOExaAtt')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data"> 12. Whether required documents are duly attested by gazatted officer / Notary / Principal of event pharmacy college of Gujarat state ? if not Mention details </p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.Docattst === 1 ? true : false} onChange={(e: any) => handleChange(e, 'Docattst')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data "> 13. Whether affidivit of Gujarat state has been Checkd and found OK? if Not Mention details </p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.AffidtOK === 1 ? true : false} onChange={(e: any) => handleChange(e, 'AffidtOK')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-12">
                                        <p className="scrutiny_data"> 14. Whether Course and Examination is approved by P.C.I inrespect of institutions _period mention under no (7) if yes mention :</p>
                                    </div>
                                </div>
                                <div className="field col-12 md:col-12">
                                    {/* Datatable */}
                                    <DataTable value={applicationDetails?.collageapproval} showGridlines stripedRows className="datatable-responsive " emptyMessage="No Data Found">
                                        <Column field="pcicirdt" header="Circular Date"></Column>
                                        <Column field="pcirefno" header="Reference No"></Column>
                                        <Column field="pciresno" header="Resolution No"></Column>
                                        <Column field="examautho" header="Examination Authority"></Column>
                                        <Column field="qualdateorg" header="Valid From"></Column>
                                        <Column field="qualdateorgf" header="Vaild To"></Column>
                                    </DataTable>
                                    {/* Datatable */}
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data"> 15. Whether Employers certificate / self declaration with required details attached</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.EmpCertAttch === 1 ? true : false} onChange={(e: any) => handleChange(e, 'EmpCertAttch')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">16. Whether the applicant is eligible for registration under section 32(2) of the Pharmacy Act 48</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.AppEligible === 1 ? true : false} onChange={(e: any) => handleChange(e, 'AppEligible')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">17. is eligible under Pharmacy amendment Act under 1976 Section 32(B)</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.EligiblePhAct === 1 ? true : false} onChange={(e: any) => handleChange(e, 'EligiblePhAct')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid">
                                    <div className="field col-12 md:col-8">
                                        {roleName === 'Scrutiny Manager' || roleName === 'Admin' ? (
                                            <>
                                                <div className="field scrutiny-note-div">
                                                    <label htmlFor="Note">Prepared Note :</label>
                                                    <InputTextarea value={scrutinyDetails?.PNote} name="PNote" onChange={(e) => handleNoteChange(e, 'PNote')} rows={4}></InputTextarea>
                                                </div>

                                                {roleName === 'Admin' ? (
                                                    ' '
                                                ) : (
                                                    <div className="scrutiny-note-label">
                                                        {' '}
                                                        <label>
                                                            {' '}
                                                            Check Note : &nbsp;
                                                            {scrutinyDetails?.CNote}
                                                        </label>
                                                        <label>
                                                            Approval Note : &nbsp;
                                                            {scrutinyDetails?.ANote}
                                                        </label>
                                                        {!window.cn(scrutinyDetails?.prepared_by) && (
                                                            <>
                                                                <br />

                                                                <label>
                                                                    Prepared By : &nbsp;
                                                                    {scrutinyDetails?.prepared_by}&nbsp;&nbsp;&nbsp;
                                                                    {convertDateTime(scrutinyDetails?.prepared_time)}
                                                                </label>
                                                            </>
                                                        )}
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            ''
                                        )}

                                        {roleName === 'Sub Registar' || roleName === 'Admin' ? (
                                            <>
                                                <div className="field scrutiny-note-div">
                                                    <label htmlFor="Note">Check Note :</label>
                                                    <InputTextarea value={scrutinyDetails?.CNote} name="CNote" onChange={(e) => handleNoteChange(e, 'CNote')} rows={4}></InputTextarea>
                                                </div>

                                                {roleName === 'Admin' ? (
                                                    ''
                                                ) : (
                                                    <>
                                                        <div className="scrutiny-note-label">
                                                            <label>
                                                                Prepared Note : &nbsp;
                                                                {scrutinyDetails?.PNote}
                                                            </label>
                                                            <label>
                                                                Approval Note : &nbsp;
                                                                {scrutinyDetails?.ANote}
                                                            </label>{' '}
                                                            {!window.cn(scrutinyDetails?.prepared_by) && (
                                                                <>
                                                                    <br />

                                                                    <label>
                                                                        Prepared By : &nbsp;
                                                                        {scrutinyDetails?.prepared_by}&nbsp;&nbsp;&nbsp;
                                                                        {convertDateTime(scrutinyDetails?.prepared_time)}
                                                                    </label>
                                                                </>
                                                            )}
                                                            {!window.cn(scrutinyDetails?.checked_by) && (
                                                                <>
                                                                    <label>
                                                                        Checked By : &nbsp;
                                                                        {scrutinyDetails?.checked_by}&nbsp;&nbsp;&nbsp;
                                                                        {convertDateTime(scrutinyDetails?.checked_time)}
                                                                    </label>
                                                                </>
                                                            )}
                                                            {!window.cn(scrutinyDetails?.approved_by) && (
                                                                <>
                                                                    <label>
                                                                        Approved By : &nbsp;
                                                                        {scrutinyDetails?.approved_by}&nbsp;&nbsp;&nbsp;
                                                                        {convertDateTime(scrutinyDetails?.approved_time)}
                                                                    </label>
                                                                </>
                                                            )}
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        ) : (
                                            ''
                                        )}

                                        {roleName === 'Registar' || roleName === 'Admin' ? (
                                            <>
                                                <div className="field scrutiny-note-div">
                                                    <label htmlFor="Note" style={{ textAlign: 'left' }}>
                                                        Approval Note :
                                                    </label>
                                                    <InputTextarea value={scrutinyDetails?.ANote} name="ANote" onChange={(e) => handleNoteChange(e, 'ANote')} rows={4}></InputTextarea>
                                                </div>

                                                {roleName === 'Admin' ? (
                                                    ''
                                                ) : (
                                                    <>
                                                        <div className="scrutiny-note-label">
                                                            <label>
                                                                {' '}
                                                                Prepared Note : &nbsp;
                                                                {scrutinyDetails?.PNote}
                                                            </label>
                                                            <label>
                                                                {' '}
                                                                Check Note : &nbsp;
                                                                {scrutinyDetails?.CNote}
                                                            </label>{' '}
                                                            {!window.cn(scrutinyDetails?.prepared_by) && (
                                                                <>
                                                                    <br />

                                                                    <label>
                                                                        Prepared By : &nbsp;
                                                                        {scrutinyDetails?.prepared_by}&nbsp;&nbsp;&nbsp;
                                                                        {convertDateTime(scrutinyDetails?.prepared_time)}
                                                                    </label>
                                                                </>
                                                            )}
                                                            {!window.cn(scrutinyDetails?.checked_by) && (
                                                                <>
                                                                    <label>
                                                                        Checked By : &nbsp;
                                                                        {scrutinyDetails?.checked_by}&nbsp;&nbsp;&nbsp;
                                                                        {convertDateTime(scrutinyDetails?.checked_time)}
                                                                    </label>
                                                                </>
                                                            )}
                                                            {!window.cn(scrutinyDetails?.approved_by) && (
                                                                <>
                                                                    <label>
                                                                        Approved By : &nbsp;
                                                                        {scrutinyDetails?.approved_by}&nbsp;&nbsp;&nbsp;
                                                                        {convertDateTime(scrutinyDetails?.approved_time)}
                                                                    </label>
                                                                </>
                                                            )}
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        ) : (
                                            ''
                                        )}
                                    </div>

                                    <div className="field col-12 md:col-2 mt-5" style={{ marginLeft: '3%' }}>
                                        {roleName == 'Scrutiny Manager' || roleName === 'Admin' ? (
                                            <>
                                                <div className="field-checkbox">
                                                    <Checkbox inputId="checkOption1" checked={scrutinyDetails?.Preparedby === 1 ? true : false} onChange={(e: any) => handleChange(e, 'Preparedby')}></Checkbox>
                                                    <label htmlFor="checkOption1">Prepared</label>
                                                </div>
                                            </>
                                        ) : (
                                            ''
                                        )}

                                        {roleName == 'Sub Registar' || roleName === 'Admin' ? (
                                            <>
                                                <div className="field-checkbox">
                                                    <Checkbox inputId="checkOption2" checked={scrutinyDetails?.Checkby === 1 ? true : false} onChange={(e: any) => handleChange(e, 'Checkby')}></Checkbox>
                                                    <label htmlFor="checkOption2">Check</label>
                                                </div>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {roleName == 'Registar' || roleName === 'Admin' ? (
                                            <>
                                                <div className="field-checkbox">
                                                    <Checkbox inputId="checkOption3" checked={scrutinyDetails?.Approvedby === 1 ? true : false} onChange={(e: any) => handleChange(e, 'Approvedby')}></Checkbox>
                                                    <label htmlFor="checkOption3">Approval</label>
                                                </div>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </div>
                            </FormWizard.TabContent>
                        </FormWizard>

                        <div className="grid justify-content-between w-100 px-5">
                            <div>
                                {roleName == 'Sub Registar' && activeIndex == 1 ? <Button label="Back to Verification" onClick={() => scrutinyCheckOpen('Verification')}></Button> : null}
                                {roleName === 'Registar' && activeIndex === 2 ? <Button label="Back to Scrutiny Prepare" onClick={() => scrutinyCheckOpen('Scrutiny Prepare')}></Button> : null}
                                {roleName !== 'Sub Registar' && roleName !== 'Registar' && activeIndex === 0 ? <Button label="Back to Pending" onClick={() => scrutinyCheckOpen('Pending')}></Button> : null}
                            </div>

                            <div>
                                {(roleName === 'Scrutiny Manager' && activeIndex === 0) || (roleName === 'Sub Registar' && activeIndex === 1) || (roleName === 'Registar' && activeIndex === 2) ? (
                                    <Button label="Save" className="ml-2 p-button p-button-success" onClick={() => saveScrutiny()} loading={saveButtonLoader} />
                                ) : (
                                    <Button label="Save" disabled tooltip="Already RegNo is assigned / Don't have access" tooltipOptions={{ position: 'top' }} className="ml-2 p-button p-button-success" />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Scrutiny Success Modal Start */}
            {!window.cn(successDetails) && successDialog === true && <ScrutinySuccessModal openmodel={successDialog} title={'Degree Addition Scrutiny'} goToApp={() => goToApp()} data={{ fileNo, roleName, name, successDetails }} />}

            {/* Scrutiny Success Modal end */}

            {/* Scrutiny Check Modal Start */}
            <Dialog
                visible={scrutinyCheckDialog}
                className="p-fluid"
                style={{ width: '550px' }}
                header={!window.cn(scrutinyCheckBtnTitle) && 'Back to ' + scrutinyCheckBtnTitle}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={() => closeScrutinyCheckDialog()} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => checkScrutiny(scrutinyCheckBtnTitle)} loading={scrutinyCheckBtnSpinner} />
                    </>
                }
                onHide={() => closeScrutinyCheckDialog()}
            >
                <h5 className="bold">Are you sure want to transfer this application?</h5>
            </Dialog>

            {/* Scrutiny Check Modal End */}

            {/* Loader */}
            {pageLoad && <Loader />}
        </>
    );
};
